export const NAME = 'forgot-password';
